'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _AddBlockMenu = require('./AddBlockMenu');

var _AddBlockMenu2 = _interopRequireDefault(_AddBlockMenu);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../util');

var _slateFunctions = require('./slateFunctions');

var _lodash = require('lodash');

var _TypeEditor = require('../TypeEditor');

var _TypeEditor2 = _interopRequireDefault(_TypeEditor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (_ref) {
  var attributes = _ref.attributes,
      readOnly = _ref.readOnly,
      node = _ref.node,
      children = _ref.children,
      editor = _ref.editor,
      isSelected = _ref.isSelected,
      isFocused = _ref.isFocused,
      parent = _ref.parent,
      _ref$types = _ref.types,
      types = _ref$types === undefined ? {} : _ref$types,
      _ref$blocks = _ref.blocks,
      blocks = _ref$blocks === undefined ? {} : _ref$blocks;
  var block = blocks[node.type];
  console.log("Rendering slate node", block, node);

  if (!block) {
    console.error("Couldn't find block type", node.type, blocks);
    return null;
  }

  var parentBlocks = parent && blocks[parent.type] ? blocks[parent.type].blockTypes : (0, _slateFunctions.rootToolbarBlockTypes)(blocks);
  console.log("Parent blocks", parentBlocks);
  var showControls = isFocused && isSelected && parentBlocks;
  var firelightType = block.type;

  if (!firelightType) {
    // render as HTML tag name
    var As = node.type;
    console.log("Rendering basic html", As, node.type);
    return _react2.default.createElement('div', {
      className: 'SlateNode-basic'
    }, _react2.default.createElement(As, (0, _extends3.default)({}, attributes, node.data.toJS()), children), _react2.default.createElement('div', {
      contentEditable: false,
      className: 'node-controls ' + (showControls ? 'showControls' : '')
    }, showControls && _react2.default.createElement(_AddBlockMenu2.default, {
      key: node.key,
      blocks: parentBlocks,
      onDelete: function onDelete() {
        return editor.change(_slateFunctions.deleteNode, node);
      },
      onAdd: function onAdd(type) {
        return editor.change(_slateFunctions.addNextNode, (0, _slateFunctions.newBlockOfType)(type, blocks));
      }
    })));
  }

  console.log('Rendering stuff', attributes, node, children);

  var onChange = function onChange(path, data) {
    if (readOnly) {
      return;
    }

    console.log("Handling change", path, data, (0, _util.noUndefineds)(data));
    editor.change(_slateFunctions.updateData, node, {
      nodeValue: (0, _util.noUndefineds)(data)
    });
  };

  var value = (node.data.toJS() || {}).nodeValue;
  return _react2.default.createElement('div', (0, _extends3.default)({}, attributes, {
    className: 'SlateNode'
  }), _react2.default.createElement('div', {
    className: 'node-content ' + (isSelected ? 'isSelected' : '') + ' ' + (isFocused ? 'isFocused' : '')
  }, true || node.isVoid ? _react2.default.createElement('div', {
    className: 'node-content-widget void-widget',
    contentEditable: false,
    onClick: _slateFunctions.stopPropagation
  }, _react2.default.createElement(_TypeEditor2.default, {
    type: firelightType,
    name: node.type,
    types: types,
    path: [],
    value: value,
    current: value,
    onChange: onChange
  })) : _react2.default.createElement('div', {
    className: 'node-content-widget'
  }, _react2.default.createElement(_TypeEditor2.default, {
    type: firelightType,
    name: node.type,
    types: types,
    path: [],
    value: value,
    current: value,
    onChange: onChange
  }, children), block.blockTypes && node.nodes.size === 0 && _react2.default.createElement(_AddBlockMenu2.default, {
    key: node.key,
    blocks: block.blockTypes,
    onDelete: function onDelete() {
      return editor.change(_slateFunctions.deleteNode, node);
    },
    onAdd: function onAdd(type) {
      return editor.change(_slateFunctions.addSubNode, node, (0, _slateFunctions.newBlockOfType)(type, blocks));
    }
  })), _react2.default.createElement('div', {
    contentEditable: false,
    className: 'node-controls ' + (showControls ? 'showControls' : ''),
    onMouseDown: _slateFunctions.stopPropagation,
    onMouseDownCapture: _slateFunctions.stopPropagation
  }, showControls && _react2.default.createElement(_AddBlockMenu2.default, {
    blocks: parentBlocks,
    key: node.key,
    onDelete: function onDelete() {
      return editor.change(_slateFunctions.deleteNode, node);
    },
    onAdd: function onAdd(type) {
      return editor.change(_slateFunctions.addSubNode, parent, (0, _slateFunctions.newBlockOfType)(type, blocks), node);
    }
  }))));
};